import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Callout } from '@bingads-webui-react/callout';
import { DefaultButton, PrimaryButton } from '@bingads-webui-react/fabric-with-signal';
import { LearnMoreLink, HelpIcon } from '@bingads-webui-campaign-react/help';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { curlyTemplate } from '@bingads-webui-universal/primitive-utilities';

import { getStyles } from './styles';

const CalloutCardInternal = ({
  i18n,
  title,
  content,
  contentHelpId,
  buttons,
  target,
  classes,
  coupon,
  couponHelpId,
  currency,
}) => {
  const contentNode = useMemo(() => (
    <div>
      <div className="conversion-coupon-callout-card-content">
        {
        coupon ?
          <div className="conversion-coupon-callout-card-coupon">
            <span>
              {curlyTemplate(i18n.getString(_TL_('Receive {{couponValue}} Credit')))({ couponValue: i18n.formatCurrency(coupon.CouponValue, currency) })}
              {
              couponHelpId ?
                <HelpIcon
                  topic={couponHelpId}
                /> : <></>
              }
            </span>
          </div> : <></>
        }
        <span>{content}</span>
        {contentHelpId
         ? <LearnMoreLink topic={contentHelpId} linkText={i18n.getString(_TL_('Learn more'))} />
         : null}
      </div>
      <div className="conversion-coupon-callout-card-buttons">
        {
          buttons.map(({ isPrimary, label, onClick }) => (
            isPrimary
              ? <PrimaryButton key="cta-button" text={label} onClick={onClick} />
              : <DefaultButton key="cancel-button" text={label} onClick={onClick} />
          ))
        }
      </div>
    </div>
  ), [buttons, content, contentHelpId, coupon, couponHelpId, currency, i18n]);

  return (
    <Callout
      title={title}
      content={contentNode}
      popoverClassName={classes.importCalloutCardPopup}
      popoverId="conversion-coupon-callout-card-popover-id"
      target={target}
      placement="bottom"
      show
      rootClose={false}
      closeButton={false}
    />
  );
};

CalloutCardInternal.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  contentHelpId: PropTypes.string,
  buttons: PropTypes.arrayOf(PropTypes.shape({
    isPrimary: PropTypes.bool,
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
  })).isRequired,
  target: PropTypes.shape({}).isRequired,
  classes: PropTypes.shape({}).isRequired,
  coupon: PropTypes.shape({}),
  couponHelpId: PropTypes.string,
  currency: PropTypes.string.isRequired,
};

CalloutCardInternal.defaultProps = {
  contentHelpId: null,
  couponHelpId: null,
  coupon: null,
};

export const CalloutCardComponent = withDefaultStyles(CalloutCardInternal, getStyles);
